import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=72a4c2cc&"
import script from "./DataModal.vue?vue&type=script&lang=ts&"
export * from "./DataModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports